
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Loading',

    setup() {
        const body = document.querySelector('body');

        if (body) body.style.overflow = 'hidden';
    },
});
